module.exports = __webpack_public_path__ + "static/media/icn_search_light.a1178d74.svg";